import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import dynamic from "next/dynamic";
import { getPageProps } from "@services/initial-calls";
import { useDomainContext } from "@hooks/useDomainContext";
import ComparePEORatesWrapper from "@components/layouts/comparepeoratesWrapper";
import OffersList from "@components/shared/offersList";
import MainBannerSingleForm from "@components/comparepeorates/mainBannerSingleForm";

const WhyUs = dynamic(() => import("@components/comparepeorates/whyUs"));

export default function ComparePEORatesHome(): ReactElement {
    const { domain } = useDomainContext();

    return (
        <ComparePEORatesWrapper>
            <MainBannerSingleForm />
            <section>
                <OffersList offers={domain?.defaultOffers} />
            </section>
            <WhyUs />
        </ComparePEORatesWrapper>
    );
}
export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "category");
};
